import React, { useEffect, useState, forwardRef, useRef, useImperativeHandle } from "react";
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { useSelector, } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { getStorePaymentDetails, passPaymentMethodToDropin } from "../../RestaurantWidget/utilities/api/paymentService";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../RestaurantWidget/utilities/helper/helper";
import globalValues from "../../../../utilities/apiRequests/globalValues";
import { bookEvent } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests";


const EventPaymentContainer = forwardRef((props, ref) => {
    const cardRef = useRef(null);
    const storeOrderLocalData = useSelector((state) => state.companyData.company);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [paymentMethods, setPaymentMethods] = useState(null)

    useEffect(() => {
        if (storeOrderLocalData) {
            handleFetchPayment()
        }

    }, [])
    const handleFetchPayment = async () => {
        if (storeOrderLocalData) {
            let ref = uuidv4();
            const requestBody = {
                clientAPIRequestRef: ref,
                cloudLocationID: storeOrderLocalData.LocationID,
                store: `Ecommerce_${storeOrderLocalData.LocationID}`
            }
            await getStorePaymentDetails(requestBody, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
                if (response) {
                    setPaymentMethods(response)
                }
            })
        }
    }

    const makeInstantPayment = async (data, orderID) => {
        return new Promise((resolve) => {
            const uniqueID = uuidv4()
            const { paymentMethod } = data
            const paymentRequestBody = {
                amount: {
                    currency: "GBP",
                    value: props?.total
                },
                cloudLocationID: storeOrderLocalData.LocationID,
                reference: `Online-${storeOrderLocalData.LocationID}-Ecom-${uniqueID}`,
                siteTransactionRef: orderID,
                returnUrl: window.location.href,
                store: `Ecommerce_${storeOrderLocalData.LocationID}`,
                countryCode: "GB",
                shopperEmail: props?.customerDetails.emailAddress.trim(),
                ShopperName: `${props?.customerDetails.firstName.trim()} ${props?.customerDetails.lastName.trim()}`,
                telephoneNumber: `+44${props?.customerDetails.phoneNumber}`,
                paymentMethod,
                isTokenized: false,
                APISource: "Web",
                shopperReference: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_LOGGED_USER_ID) : localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                additionalData: {
                    "allow3DS2": "true"
                },
            }
            let req = {
                "BookingID": orderID,
                "PaymentMethod": "CARD",
                "PaymentToken": "",
                "LastFourDigits": "",
                "PaymentRefNo": `Online-${storeOrderLocalData.LocationID}-Ecom-${uniqueID}`
            }
            sessionStorage.setItem("event_ref_p", JSON.stringify(req))
            passPaymentMethodToDropin(paymentRequestBody, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {

                resolve(response)
            }).catch(error => {
                props?.setShowCheckout(false)
                props.setIsBookingFailed(true)
            });
        })

    }

    const handleTransaction = (stage) => {
        if (stage === "Authorised" || stage === "Received" || stage === "AuthenticationNotRequired") {
            props?.setIsPaymentLoading(false)

        }
        else if (stage === "ChallengeShopper" || stage === "PresentToShopper" || stage === "AuthenticationNotRequired" || stage === "RedirectShopper" || stage === "IdentifyShopper") {


        } else {
            props?.setShowCheckout(false)
            props?.setIsPaymentLoading(false)
            props.setIsBookingFailed(true)

        }
    }
    useEffect(() => {
        const initCheckout = async () => {

            const configuration = {
                paymentMethodsResponse: paymentMethods, // The `/paymentMethods` response from the server.
                clientKey: globalValues.payment.REACT_APP_PAYMENT_CLIENT_KEY, // Web Drop-in versions before 3.10.1 use originKey instead of clientKey.
                locale: "en-US",
                environment: globalValues.payment.REACT_APP_PAYMENT_CLIENT_ENVIRONMENT,
                analytics: {
                    enabled: true // 
                },
                onSubmit: (state, dropin) => {
                    if (state.data.storePaymentMethod === false) {
                        if (props?.items) {
                            props?.setIsPaymentLoading(true)
                            const user = localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_LOGGED_USER_ID) : localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID)
                            const req = {
                                "CustomerDetails": {
                                    "ID": user,
                                    "Name": `${props?.customerDetails.firstName.trim()} ${props?.customerDetails.lastName.trim()}`,
                                    "Email": props?.customerDetails.emailAddress.trim(),
                                    "PhoneNo": {
                                        "CountryCode": "+44",
                                        "Number": props?.customerDetails.phoneNumber.replace("+44", "")
                                    },
                                    "Country": "United Kingdom",
                                    "Address": "",
                                    "PostalCode": ""
                                },
                                "EventDetails": {
                                    "ID": props.eventID
                                },
                                "BookingDetails": props?.items
                            }
                            bookEvent(req).then((res) => {
                                if (res) {
                                    sessionStorage.setItem("eventOID", res?.BookingID)
                                    makeInstantPayment(state.data, res?.BookingID)
                                        .then((response) => {
                                            if (response.action) {
                                                dropin.handleAction(response.action);
                                            } else {
                                                handleTransaction(response.resultCode)
                                            }
                                        }).catch((error) => {
                                            props?.setShowCheckout(false)
                                            props.setIsBookingFailed(true)

                                        })

                                } else {
                                    props?.setShowCheckout(false)
                                    props.setIsBookingFailed(true)
                                }
                            }).catch((error) => {
                                props?.setShowCheckout(false)
                                props.setIsBookingFailed(true)

                            })

                        }
                    }
                },
                paymentMethodsConfiguration: {
                    card: {
                        hasHolderName: true,
                        holderNameRequired: true,
                        enableStoreDetails: true,
                        hideCVC: false,
                        showPayButton: false
                    }
                }
            };

            const checkout = await AdyenCheckout(configuration);
            const card = checkout
                .create('card', {
                    openFirstPaymentMethod: false,
                })
            card.mount('#event-card-container');
            cardRef.current = card;

        }
        if (paymentMethods)
            initCheckout()
    }, [paymentMethods, props.customerDetails])

    useImperativeHandle(ref, () => ({
        submit: () => {
            const card = cardRef.current;
            if (card && card.isValid) {
                card.submit();
                props?.setShowPaymentErrorModal(false)
            } else {
                props?.setShowPaymentErrorModal(true)
            }
        }
    }));
    return <div id="event-card-container"></div>
})
export default EventPaymentContainer